<template>
  <div class="suspension" >
        <van-image
          width="32"
          height="32"
          :src="require('@/assets/share1.png')"
        ></van-image>
        <span>APP内打开</span>
        <wx-open-launch-app class="openApp" appid="wxa496fd5f0644bb66" :extinfo="extinfo" @error="openAppErr">
          <script type="text/wxtag-template">
            <div style="position: absolute; top: 0; left: 0;width: 100%; height:100%;opacity: 0;">
            此div必须有内容才可点击，但不能在页面上展示，固采用透明度隐藏此div
            </div>
          </script>
        </wx-open-launch-app>
      </div>
</template>

<script>
export default {
  props: {
    extinfo: {
      type: String
    }
  },
  methods: {
    openAppErr () {
      window.open('https://a.app.qq.com/o/simple.jsp?pkgname=yslt.art.app', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.suspension {
  width: 146px;
  height: 45px;
  background: rgba(196, 148, 107, 0.9);
  font-size: 16px;
  color: #fff;
  position: fixed;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  > span {
    margin-left: 10px;
  }
}
.openApp {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
</style>
